import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ZTransformDifferenceEquation = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Application of Z-Transform in Difference Equations"
    videos={[
      "https://www.youtube.com/embed/bC9HxjgNy44",
      "https://www.youtube.com/embed/O1bS1U2yj4w",
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default ZTransformDifferenceEquation;
